<template>
  <el-dialog :visible="modifyPwdVisible"  :append-to-body="true" class="modify-password-dialog" width="358px"
    @open="onOpen" @close="onClose">
    <div slot="title">
      <i class="edit-icon el-icon-edit"></i>
      <span>修改密码</span>
    </div>
    <el-form ref="pwdForm" class="passwordForm">
        <!-- <el-form-item :label="`新密码${columnSeparator}`">
          <el-input v-model="resetPassWord" maxlength="18"> </el-input>
        </el-form-item> -->
        <el-form-item>
          <el-input v-model.trim="resetPassWord" :type="showPassword ? 'password' : ''"
            placeholder="设置新密码(6-18个字，包括字母和数字)" autocomplete="new-password" />
          <span class="show-pwd" @click="showPassword = !showPassword">
            <i v-if="showPassword" class="BLM-icon-view-close" />
            <i v-else class="BLM-icon-view" />
          </span>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onClose">取消</el-button>
      <el-button type="primary" @click="onConfirm" :loading="oLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { validatePassWord } from '@/utils/validate'
import { resetPassword as company } from '@/api/company'
import { resetPassword as tenant } from '@/api/tenant'
import { resetPassword as hobo } from '@/api/hoboAPi'

export default {
  components: {
  },
  props: {
    modifyPwdVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resetPassWord: '',
      showPassword: true,
      oLoading: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    onOpen() {
      this.resetValue()
      this.$nextTick(() => {
        this.$refs.pwdForm.clearValidate()
      })
    },
    onClose() {
      this.resetValue()
      this.$emit('updateVisible', false)
    },
    resetValue() {
      this.resetPassWord = ''
    },
    async onConfirm() {
      if (!validatePassWord(this.resetPassWord)) {
        this.$message.error('密码只能是6-18位的数字或字母')
        return
      }
      this.oLoading = true
      try {
        const { userType } = this.userInfo
        const params = {
          id: this.$store.getters.userInfo.id,
          password: this.resetPassWord,
        }
        let res = {}
        if (userType === 100) {
          res = await hobo(params)
        } else if (userType === 200 || userType === 201) {
          res = await tenant(params)
        } else if (userType === 300 || userType === 301) {
          res = await company(params)
        }
        const { code } = res
        this.oLoading = false
        if (code === 1) {
          this.resetPassWord = ''
          this.onClose()
          this.$message.success('操作成功')
          this.logout()
        }
      } catch (error) {
        this.oLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
$light_gray: rgba(0, 0, 0, 0.7);
$dark_gray: #889aa4;

.passwordForm {
  ::v-deep .el-form-item {
    color: #C8C9CC;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 2px;

    .el-form-item__content {
      display: flex;
    }

    .el-form-item__error {
      padding-top: 4px;
      color: #EA0000;
    }

    .el-input__inner {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 0px 8px;
      color: $light_gray;
      height: 47px;

      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
        -webkit-text-fill-color: #232323 !important;
      }
    }
    .el-input__inner:focus,.el-input__inner:hover {
      box-shadow: none;
      border: none;
    }

    .show-pwd {
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
    }

    .captcha-btn,
    .show-pwd {
      line-height: 45px;
      float: right;
      padding: 0;
      padding-right: 16px;
    }
  }
}

.edit-icon {
  margin-right: 6px;
}
</style>

